module.exports = __webpack_public_path__ + "img/AT0000002662300.1b92084b.png";